import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GraphqlService } from '../../common/services/graphql.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-under-development',
  templateUrl: './under-development.component.html',
})
export class UnderDevelopmentComponent implements OnInit, OnDestroy {

  constructor(private route: Router, private graphQLService: GraphqlService) { }
  pageStatus: string = "";
  navData;
  event$
  outcome: boolean = false;
  ngOnInit(): void {
    this.outcome = false;
    if (this.route.url.includes("QuestionNotUsed")) {
      this.pageStatus = "[Question number not used.]";
      this.graphQLService.GetBreadcrumb(this.route.url.split("/")[1]).subscribe(navData => { console.log(navData); this.navData = navData; this.outcome = true; });
    }
    else {
      this.pageStatus = "The page is under development."; this.outcome = true;
    }
    this.event$
      = this.route.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
      .subscribe(() => {
        this.outcome = false;
          if (this.route.url.includes("QuestionNotUsed")) {
            this.pageStatus = "[Question number not used.]";
            this.graphQLService.GetBreadcrumb(this.route.url.split("/")[1]).subscribe(navData => { console.log(navData); this.navData = navData; this.outcome = true;});
          }
          else {
            this.pageStatus = "The page is under development."; this.outcome = true;
          }
        });
  }

  ngOnDestroy() {
    this.event$.unsubscribe();
  }

}
